module.exports = __webpack_public_path__ + "static/media/Electrificacion_Coccion_Hogar.86189606.png";